import React from "react";
import ReactApexChart from "react-apexcharts";
import ArrowRightIcon from "../ArrowRightIcon";
import { useNavigate } from "react-router-dom";

const ActiveInactiveChart = ({ title, data, viewAllLink, colors }) => {
  const navigate = useNavigate();
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const isMerchant = title.toLowerCase().includes("merchant");

  const series = [
    {
      name: "Active",
      data: Array.isArray(data?.active) ? data.active : [],
    },
    {
      name: "Inactive",
      data: Array.isArray(data?.inactive) ? data.inactive : [],
    },
  ];

  if (isMerchant) {
    series.push({
      name: "Without Offers",
      data: Array.isArray(data?.withoutOffers) ? data.withoutOffers : [],
    });
  }

  const chartColors = isMerchant
    ? ["#4CAC5B", "#EF4444", "#9CA3AF"] // Green, Red, Gray
    : colors || ["#4CAC5B", "#5470C6"];

  const chartData = {
    series,
    options: {
      chart: {
        type: "bar",
        toolbar: {
          show: false,
        },
      },
      colors: chartColors,
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "70%",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: months,
        labels: {
          style: {
            fontSize: "12px",
            fontFamily: "Poppins, sans-serif",
          },
        },
      },
      yaxis: {
        title: {
          text: "Count",
          style: {
            fontSize: "14px",
            fontWeight: 400,
            fontFamily: "Poppins, sans-serif",
          },
        },
        labels: {
          style: {
            fontSize: "12px",
            fontFamily: "Poppins, sans-serif",
          },
        },
      },
      legend: {
        show: true,
        position: "bottom",
        horizontalAlign: "center",
        fontSize: "14px",
        fontFamily: "Helvetica, Arial",
        fontWeight: 400,
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
    },
  };

  return (
    <div className="summary w-full p-4 h-[470px] flex flex-col bg-white rounded-lg">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 mb-4">
        <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
        {viewAllLink && (
          <button
            onClick={() => navigate(viewAllLink)}
            className="text-[#00ADEF] text-[16px] font-poppins font-[500] border border-[#00ADEF] rounded-[6px] px-4 py-2 transition hover:bg-[#E6F7FB] flex items-center"
          >
            View All
            <ArrowRightIcon className="ml-2" />
          </button>
        )}
      </div>
      <div className="flex-1 min-h-0">
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height="100%"
        />
      </div>
    </div>
  );
};

export default ActiveInactiveChart;
